import React from 'react';
var axios = require('axios');
var constants = require("../constants/constants");

export default class FactoryInformationPage extends React.Component {
    constructor(props) {
        super(props);
        let CompanyId = localStorage.getItem('CompanyId') || 1;
        this.state = {
            FactoFactoryInforyList: [],
            FactoryInfo: [],
            CompanyId: CompanyId,
        };
    }

    componentWillMount() {
        var user = JSON.parse(sessionStorage.getItem("User"));
        let currentComponent = this;
        axios.get(constants.config.HOST + constants.api.GET_TRANSPORTER_DETAILS_INFORMATION, {
            params: { TransportersId: user.TransportersId, YearId: user.TargetYearId, CompanyId: '0', Action: 'Transporter' }
        }).then(function (response) {
            currentComponent.setState({ FactoryInfo: response.data })
            console.log(response.data)
        }).catch(function (error) {
            console.log(error);
        });
    }

    Factoryinfo(e, CompanyId) {
        this.setState({
            iskarkhanaDetails: true,
        });
        localStorage.setItem('CompanyId', CompanyId);
        this.props.history.push({
            pathname: '/KarkhanaList_details_Information',
            CompanyId: CompanyId,
        })
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    render() {
        let currentComponent = this;
        return (
            <div>
                <div data-page="form" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div className="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                        </div>
                        <br /> <br /><br />
                        <tr>
                            <h3 style={{ 'color': '#0000FF' }}><b style={{ 'padding-left': '30px' }}>कारखान्याने मागवलेली माहिती</b></h3>
                        </tr>
                        {
                            this.state.FactoryInfo.map(function (Transporter, index) {
                                return (
                                    <div class="card">
                                        <b style={{ 'color': '#0099FF' }}>    {Transporter.CompanyName}</b>&nbsp;&nbsp;&nbsp;
                                      <button type="button" class="btn btn-info" style={{
                                            // float: 'right',
                                            padding: '5px 20px 7px 10px',
                                            margin: '10px 0px 5px 225px'
                                        }} onClick={(e) => currentComponent.Factoryinfo(e, Transporter.CompanyId)}> माहिती पहा </button>

                                    </div>
                                )
                            })
                        }
                    </div>

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/FactoryInformationPage.jsx